const truncateString = (string, length) => {
    if (string.length > length) return string.substring(0, length) + '...'; // if the string is longer than the length, truncate it
    else return string; // otherwise, return the string as is
};
export default truncateString;